import I18n from "i18n-js";
import { makeAutoObservable } from "mobx";
import { RDate } from "../../core";
import { OnTimeFulfillmentTime, } from "../../ordering";
import { RArray } from "../../collections";
export class PInFutureFulfillmentTime {
    constructor(params) {
        this.type = "InFuture";
        this.restaurant = params.restaurant;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        this.purchaseOrder = params.purchaseOrder;
        this.label = I18n.t("orders.form.choose_date");
        makeAutoObservable(this);
    }
    get domain() {
        return this.fulfillmentInstructions.fulfillmentTime;
    }
    get isAvailable() {
        return (this.purchaseOrder.isPreorder &&
            this.purchaseOrder.availableDateRange !== null &&
            !this.isTodayDate(this.purchaseOrder.availableDateRange.end.fullDate));
    }
    get isActive() {
        return (this.isAvailable && this.domain !== null && this.domain.type === "OnTime");
    }
    get dateRange() {
        var _a, _b;
        return {
            min: (_a = this.purchaseOrder.availableDateRange) === null || _a === void 0 ? void 0 : _a.begin.fullDate,
            max: (_b = this.purchaseOrder.availableDateRange) === null || _b === void 0 ? void 0 : _b.end.fullDate,
        };
    }
    get hours() {
        if (this.domain === null || this.domain.type !== "OnTime") {
            return RArray.empty();
        }
        return this.isTodayDate(this.domain.date.fullDate)
            ? this.todayHours
            : this.futureHours;
    }
    isTodayDate(date) {
        return date == RDate.now(this.restaurant.timezone).fullDate;
    }
    get todayHours() {
        if (this.restaurant.fulfillmentTimes === null) {
            return RArray.empty();
        }
        return this.restaurant.fulfillmentTimes.mapOptional((item) => item.type === "OnTime" ? item.date.fullHour : null);
    }
    get futureHours() {
        if (this.domain === null || this.domain.type !== "OnTime") {
            return RArray.empty();
        }
        return this.inFutureHours(this.domain.date);
    }
    inFutureHours(date) {
        return this.restaurant.orderingHours
            .fulfillmentDates(date)
            .map((item) => item.fullHour);
    }
    // TODO: what if first available date don't has hours?
    setDefaultValue() {
        const firstAvailableDate = this.dateRange.min;
        if (firstAvailableDate !== undefined) {
            this.setDate(firstAvailableDate);
        }
    }
    setDate(value) {
        const date = RDate.fromString(value, this.restaurant.timezone);
        // TODO: what if date is not valid?
        if (!date.isValid) {
            return;
        }
        const firstAvailableHour = this.isTodayDate(date.fullDate)
            ? this.todayHours.find(0)
            : this.inFutureHours(date).find(0);
        if (firstAvailableHour !== null) {
            this.fulfillmentInstructions.fulfillmentTime = new OnTimeFulfillmentTime({
                date: RDate.fromDateAndTime(date, RDate.fromTimeString(firstAvailableHour, date.tz)),
            });
        }
        else {
            this.fulfillmentInstructions.fulfillmentTime = null;
        }
    }
    setHour(value) {
        const hour = RDate.fromTimeString(value, this.restaurant.timezone);
        const date = this.domain !== null && this.domain.type === "OnTime"
            ? this.domain.date
            : null;
        // TODO: what if time is not valid?
        if (date === null || !hour.isValid) {
            return;
        }
        this.fulfillmentInstructions.fulfillmentTime = new OnTimeFulfillmentTime({
            date: RDate.fromDateAndTime(date, hour),
        });
    }
}
